module.exports = __webpack_public_path__ + "img/37.3d18ab6f.webp";